import { render, staticRenderFns } from "./xiuxianDetail.vue?vue&type=template&id=41b5094d&scoped=true"
import script from "./xiuxianDetail.vue?vue&type=script&lang=js"
export * from "./xiuxianDetail.vue?vue&type=script&lang=js"
import style0 from "./xiuxianDetail.vue?vue&type=style&index=0&id=41b5094d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b5094d",
  null
  
)

export default component.exports